import axiosInstance from "./AxiosInstance";

// ✅ Example: PUT request (update)
export const getDashboardDetails = async (userId, updateData) => {
  try {
    const response = await axiosInstance.get("/api/dashboard");
    return response.data;
  } catch (error) {
    console.error("Error getting dashboard details:", error);
    throw error;
  }
};

